import React from 'react';
import InvoicesTable from '../InvoicesTable';

export default function SupplierInvoicesIndexPage() {
	return <InvoicesTable handleQueryParams enableViews enableMultiSelect enableBannerMessages />;
}
